export const BUSINESS = {
  name: "P&C",
  fullName: "P&C Zulassungsdienst Berlin",
  owner: "Caner Tanriver",
  phoneDisplay: "+49 176 24249346",
  phoneTel: "+4917624249346",
  whatsapp: "4917624249346",
  email: "pc-zulassungsdienst@gmx.de",
  street: "Schenkendorfstr. 4",
  city: "10965 Berlin",
};

export const HOURS = [
  ["Mo – Do", "10:00 – 18:00"],
  ["Freitag", "10:00 – 13:00"],
  ["Sa – So", "Geschlossen"],
];

// Google-Bewertungen (Stand 03.11.2026, Google Maps)
export const GOOGLE_RATING = { score: "4,8", count: 82 };
export const REVIEWS = [
  { author: "Anton Dathe", text: "Sehr guter Service! Freundlich, zuverlässig und schnell. Die Abwicklung war unkompliziert und professionell. Kann ich absolut weiterempfehlen." },
  { author: "Ben Tor", text: "Absolut empfehlenswert. Der Kollege Herr Tanriver hat sich schnell um meine Unterlagen und die Zulassung gekümmert. Gleichzeitig konnte ich mich über verschiedene Versicherungsmöglichkeiten bei der WWK informieren. Freundliche Beratung, schnelle Bearbeitung und ein sehr guter Service. Werde ich auf jeden Fall weiterempfehlen." },
  { author: "Hilmi Mede", text: "Super Zulassungsdienst! Alles ging schnell, unkompliziert und zuverlässig. Sehr freundlicher Kontakt und man kümmert sich wirklich um alles. Hat alles problemlos funktioniert und ich war sehr zufrieden. Kann ich definitiv weiterempfehlen!" },
  { author: "Dennis Pyplatz", text: "Rundum zufrieden. Der Prozess lief reibungslos und schnell und dazu ein sehr netter Service. Gerne immer wieder." },
  { author: "Selçuk Battal", text: "Wir bedanken uns für die gute und schnelle Arbeit sowie die freundliche und kompetente Unterstützung. Wir sind als Firma sehr zufrieden und können den Service absolut weiterempfehlen. Vielen Dank." },
];
export const GOOGLE_REVIEWS_URL = "https://www.google.com/maps/place/P%26C+Zulassungsdienst/@52.4673303,13.4423193,17z/data=!4m8!3m7!1s0x47a847641f8b5671:0x10ff152e24ba31cd!8m2!3d52.4673303!4d13.4423193!9m1!1b1!16s%2Fg%2F11whw_lj81";

export const telLink = `tel:${BUSINESS.phoneTel}`;
export const whatsappLink = `https://wa.me/${BUSINESS.whatsapp}?text=${encodeURIComponent(
  "Hallo, ich habe eine Frage zur Kfz-Zulassung."
)}`;

export const SERVICES = [
  { name: "KFZ-Anmeldung inkl. Wunschkennzeichen", price: 120 },
  { name: "KFZ-Ummeldung ohne Kennzeichenwechsel", price: 85 },
  { name: "KFZ-Abmeldung", price: 35 },
  { name: "Kurzzeitkennzeichen", price: 120 },
  { name: "Ausfuhrkennzeichen", price: null },
  { name: "Online-Zulassung", price: null },
  { name: "Express-Zulassung", price: 180 },
  { name: "Abhol- und Bringservice für Dokumente", price: 35 },
  { name: "2× KFZ-Kennzeichen", price: 30 },
  { name: "Kennzeichenverlust / Diebstahl", price: 130 },
  { name: "Technische Änderung", price: 80 },
  { name: "Adress- und Namensänderung", price: 75 },
];
export const formatPrice = (p) => (p == null ? "auf Anfrage" : `${p} €`);
export const DEFAULT_SERVICE = SERVICES[0].name;

export const DOCUMENTS = {
  Anmeldung: [
    "Personalausweis oder Reisepass",
    "Zulassungsbescheinigung Teil I",
    "Zulassungsbescheinigung Teil II",
    "eVB-Nummer Ihrer Versicherung",
    "SEPA-Mandat für die Kfz-Steuer",
    "Vollmacht, die ich Ihnen schicke",
  ],
  Ummeldung: [
    "Personalausweis oder Reisepass",
    "Zulassungsbescheinigung Teil I und Teil II",
    "eVB-Nummer Ihrer Versicherung",
    "SEPA-Mandat für die Kfz-Steuer",
    "Bisherige Kennzeichen (falls vorhanden)",
    "Vollmacht, die ich Ihnen schicke",
  ],
  Abmeldung: [
    "Zulassungsbescheinigung Teil I",
    "Beide Kennzeichen mit Siegel",
    "Ausweiskopie des Halters",
    "Vollmacht, die ich Ihnen schicke",
  ],
  Kurzzeitkennzeichen: [
    "Personalausweis oder Reisepass",
    "eVB-Nummer für Kurzzeitkennzeichen",
    "Fahrzeugpapiere (Teil I oder Teil II)",
    "Gültiger HU-Nachweis",
    "Vollmacht, die ich Ihnen schicke",
  ],
};

export const NUMBER_WORDS = ["Null", "Eine", "Zwei", "Drei", "Vier", "Fünf", "Sechs", "Sieben"];
